(function () {
  'use strict';

  if (!('ontouchstart' in window)) return;

  function buildSwiper(modal) {
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return null;

    var imgs = Array.from(content.querySelectorAll('img[data-media-id]'));
    if (!imgs.length) return null;

    // Swiper DOM を構築
    var swiperEl = document.createElement('div');
    // 'active' クラスが必要: Dawn の CSS が .active 以外を display:none にするため
    swiperEl.className = 'swiper product-modal-swiper active';

    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    imgs.forEach(function (img) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.setAttribute('data-media-id', img.getAttribute('data-media-id'));

      var zoomBox = document.createElement('div');
      zoomBox.className = 'swiper-zoom-container';

      var newImg = document.createElement('img');
      newImg.src = img.src;
      if (img.srcset) newImg.srcset = img.srcset;
      newImg.sizes = '100vw';
      newImg.alt = img.alt || '';
      newImg.loading = 'eager';
      newImg.draggable = false;

      zoomBox.appendChild(newImg);
      slide.appendChild(zoomBox);
      wrapper.appendChild(slide);
    });

    swiperEl.appendChild(wrapper);
    content.innerHTML = '';
    content.appendChild(swiperEl);

    var swiper = new window.Swiper(swiperEl, {
      zoom: { maxRatio: 4, toggle: true },
      slidesPerView: 1,
      spaceBetween: 0,
    });

    return { swiper: swiper, imgs: imgs };
  }

  function findIndex(imgs, mediaId) {
    if (!mediaId) return 0;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('data-media-id') === mediaId) return i;
    }
    return 0;
  }

  function main() {
    var modal = document.querySelector('product-modal');
    if (!modal) return;

    var data = null;

    // showActiveMedia をオーバーライド
    var originalShowActiveMedia = Object.getPrototypeOf(modal).showActiveMedia;

    modal.showActiveMedia = function () {
      if (!data) {
        if (originalShowActiveMedia) originalShowActiveMedia.call(this);
        return;
      }
      var id = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
      data.swiper.slideTo(findIndex(data.imgs, id), 0);
    };

    new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        if (!data) data = buildSwiper(modal);
        if (!data) return;
        var id = modal.openedBy ? modal.openedBy.getAttribute('data-media-id') : null;
        data.swiper.slideTo(findIndex(data.imgs, id), 0);
        data.swiper.zoom.out();
      } else if (data) {
        data.swiper.zoom.out();
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }
})();
